import { store, authActions } from "../app/store";
import { history } from "./history";

export const fetchWrapper = {
  get: request("GET"),
  getResponse: request("GET", true),
  post: request("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
};

function request(method, returnResponse = false) {
  return (url, body, formData, customHeaders) => {
    const requestOptions = {
      method: method,
      headers: { ...authHeader(url), Accept: "application/json" },
      credentials: "include",
    };

    if (customHeaders) {
      for (const i in customHeaders) {
        requestOptions.headers[i] = customHeaders[i];
      }
    }

    if (body && !formData) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
      requestOptions.headers["Accept"] = "application/json";
    }

    if (body && !!formData && !customHeaders) {
      // PHP does not reliably populate multipart PUT/PATCH payloads, so tunnel the method.
      if (method !== "POST") {
        requestOptions.method = "POST";
        body.append("_method", method);
      }
      requestOptions.body = body;
    }

    return fetch(url, requestOptions).then((response) => (
      returnResponse && response.ok ? response : handleResponse(response)
    ));
  };
}

function authHeader(url) {
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || "";
  const isApiUrl = apiEndpoint && url.startsWith(apiEndpoint);
  const headers = {};

  if (isApiUrl) {
    headers["X-XSRF-TOKEN"] = getCookie("XSRF-TOKEN");
  }

  return headers;
}

function handleResponse(response) {
  const contentType = response.headers.get("content-type") || "";

  if (
    (response.ok && contentType.includes("application/pdf")) ||
    contentType.endsWith(".sheet") ||
    contentType.includes("text/csv")
  ) {
    return response.blob();
  }

  if (response.ok) {
    return response.text().then((text) => {
      if (!text) return null;

      try {
        return JSON.parse(text);
      } catch (err) {
        return text;
      }
    });
  }

  return response.text().then((text) => {
    let data = text;

    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = text;
    }

    if ([401].includes(response.status)) {
      store.dispatch(authActions.resetUser());
    } else if ([403].includes(response.status)) {
      history.navigate("/", {
        state: {
          status: 403,
        },
      });
    }

    return Promise.reject(data);
  });
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
